import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import axios from "axios";

// Route guard for a module's pages. Reads the same UserAppAccess rows the home
// page uses (api/user/module/access/) and sends users without a row for
// ``moduleId`` back to the home page, so a restricted module cannot be opened
// by typing its URL. The backend enforces the same rule on the module's API
// prefix (userapp.module_access.ModuleAccessMiddleware); this guard only keeps
// the pages from rendering into a wall of 403s.
//
// Renders nothing while the lookup is pending.
export function fetchModuleAccess(userId) {
  return axios
    .get(`api/user/module/access/?auth_user_id=${userId}`)
    .then((res) => (res.data || []).filter((row) => !row.is_deleted).map((row) => row.module_id));
}

export default function ModuleRoute({ moduleId }) {
  const [state, setState] = useState("pending"); // pending | granted | denied | unauthenticated
  const storedUserId = localStorage.getItem("userId");
  const noUser = !storedUserId || storedUserId === "null" || storedUserId === "undefined";

  useEffect(() => {
    if (noUser) return undefined;
    let cancelled = false;
    fetchModuleAccess(storedUserId)
      .then((modules) => {
        if (!cancelled) setState(modules.includes(moduleId) ? "granted" : "denied");
      })
      .catch((err) => {
        console.error(err);
        if (!cancelled) setState(err?.response?.status === 401 ? "unauthenticated" : "denied");
      });
    return () => {
      cancelled = true;
    };
  }, [moduleId, storedUserId, noUser]);

  if (noUser || state === "unauthenticated") return <Navigate to="/login" replace />;
  if (state === "pending") return null;
  if (state === "denied") return <Navigate to="/" replace />;
  return <Outlet />;
}
